import { getOperatorDisplay } from "../config/schema-utils";
import { useStructuredSearchStore } from "../stores";

interface OperatorLabelProps {
  operator?: string;
  field?: string;
  nestedKey?: string;
}

const OperatorLabel = ({ operator, field, nestedKey }: OperatorLabelProps) => {
  const store = useStructuredSearchStore();
  return getOperatorDisplay(store.schema, { operator, field, nestedKey });
};

export default OperatorLabel;
